import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Container, Row } from 'react-bootstrap';
import dryage1 from '../../media/dryage1.jpeg';
import dryage2 from '../../media/dryage2.jpeg';

const DryAge = () => {
    return (
        <div>
            <Header></Header>
            <Container className="my-5 py-0 py-lg-5">
                <Row xs={1} md={2} className="g-4 mb-5 py-lg-5 py-0 d-flex align-items-start">
                    <div className="col-11 col-md-12 col-lg-6 mx-auto text-start order-2 order-lg-1">
                        <h2 className="fw-bold">We Dry Age our steaks in house for 30-60 days.
                        </h2>
                        <p className="fs-5">The process of dry-aging meat goes back to around the 1950s when butchers discovered curing meat through the dry-aging process created a more tender and tasty steak. The flavor of the meat matures with the aging process to produce a richer flavor which intensifies as the meat continues to age until the optimal aging has been reached.</p>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 order-1 order-lg-2">
                        <img className="img-fluid" src={dryage1} alt="" />
                    </div>

                </Row>
                <Row xs={1} md={2} className="g-4 my-lg-5 pt-lg-5 d-flex align-items-start">
                    <div className="col-12 col-md-12 col-lg-6">
                        <img className="img-fluid" src={dryage2} alt="" />
                    </div>
                    <div className="col-11 col-md-12 col-lg-6 mx-auto text-start">
                        <h2 className="fw-bold">Why does dry aging a steak make it so much better?
                        </h2>
                        <p className="fs-5"> Two major things happen when you allow a slab of beef to dry-age. First, naturally-present enzymes in the meat break down some of the collagen, which holds muscle fibers together and causes steaks to toughen while cooking. With collagen out of the way, the end result is much more tender.</p>
                        <p className="fs-5">In short, more flavor & tenderness.</p>
                    </div>
                </Row>
            </Container>
            <Footer></Footer>
        </div>
    );
};

export default DryAge;